import { createFileRoute } from '@tanstack/react-router';

import { OrbitOneRoute } from './-orbitOne/OrbitOneRoute.tsx';

export const Route = createFileRoute('/(app)/orbitOne')({
  component: OrbitOneRoute,
});
